import clsx from "clsx";
import type { SyntheticEvent } from "react";
import { Dropdown } from "react-bootstrap";
import { MobileTooltip } from "../MobileTooltip.tsx";
import type { DataTableRowMetadata } from "./index.tsx";
import i18n from "../../util/i18n.ts";

const style = {
	height: 27,
	marginRight: 6,
};

const Controls = ({
	alwaysShowBulkSelectRows,
	bulkSelectRows,
	enableFilters,
	hideAllControls,
	metadataType,
	mobileControlsHidden,
	mobilePrunedControls,
	name,
	onBulkSelectRows,
	onResetTable,
	onSearch,
	onToggleFilters,
	searchText,
}: {
	alwaysShowBulkSelectRows: boolean;
	bulkSelectRows: boolean;
	enableFilters: boolean;
	hideAllControls?: boolean;
	metadataType: DataTableRowMetadata["type"] | undefined;
	mobileControlsHidden: boolean;
	mobilePrunedControls: boolean;
	name: string;
	onBulkSelectRows: () => void;
	onResetTable: () => void;
	onSearch: (a: SyntheticEvent<HTMLInputElement>) => void;
	onToggleFilters: () => void;
	searchText: string;
}) => {
	const actionsText = i18n.t("dataTable.actions", {
		ns: "ui",
		defaultValue: "Actions",
	});
	const filterText = i18n.t("dataTable.filter", {
		ns: "ui",
		defaultValue: "Filter",
	});
	if (mobileControlsHidden) {
		return null;
	}

	// flex-grow-1 is so the search input expands to its max-width when possible, and then ms-auto needs to be on the inner div otherwise it doesn't do anything
	return (
		<div className="d-flex flex-grow-1 ms-1" data-datatable-controls="">
			<div className="ms-auto" />
			{!hideAllControls ? (
				<>
					{mobilePrunedControls ? null : (
						<>
							<MobileTooltip title={filterText}>
								<a
									aria-label={filterText}
									className={clsx(
										"btn btn-sm btn-light-bordered cursor-pointer",
										{
											active: enableFilters,
										},
									)}
									onClick={onToggleFilters}
									data-datatable-filter-toggle=""
									data-datatable-filters-visible={enableFilters ? "true" : "false"}
									style={style}
								>
									<span className="glyphicon glyphicon-filter" />
								</a>
							</MobileTooltip>
						</>
					)}
					<input
						className="form-control form-control-sm datatable-search mb-2"
						data-datatable-search=""
						onChange={onSearch}
						placeholder={i18n.t("dataTable.search", { ns: "ui", defaultValue: "Search" })}
						type="search"
						value={searchText}
					/>
				</>
			) : null}
			<Dropdown>
				<Dropdown.Toggle
					bsPrefix="no-caret"
					className="datatable-actions-toggle"
					id={`datatable-controls-${name}`}
					style={{
						cursor: "pointer",
						fontSize: 16,
					}}
					aria-label={actionsText}
					data-datatable-controls-menu-toggle=""
					variant="btn-link border-0"
				>
					<span className="glyphicon glyphicon-option-vertical text-body-secondary" />
				</Dropdown.Toggle>
				<Dropdown.Menu data-datatable-controls-menu="">
					{metadataType === "player" && !mobilePrunedControls ? (
						<Dropdown.Item
							data-datatable-bulk-select-toggle=""
							data-datatable-bulk-select-visible={bulkSelectRows ? "true" : "false"}
							onClick={onBulkSelectRows}
						>
							{bulkSelectRows
								? i18n.t("dataTable.hideBulkSelect", { ns: "ui", defaultValue: "Hide bulk select" })
								: i18n.t("dataTable.bulkSelect", { ns: "ui", defaultValue: "Bulk select" })}
							{alwaysShowBulkSelectRows ? ` ${i18n.t("dataTable.actions2", { ns: "ui", defaultValue: "actions" })}` : null}
						</Dropdown.Item>
					) : null}
					<Dropdown.Item data-datatable-reset-table="" onClick={onResetTable}>{i18n.t("dataTable.resetTable", { ns: "ui", defaultValue: "Reset table" })}</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</div>
	);
};

export default Controls;
